
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Chip,
    Container,
    Dialog,
    Divider,
    Fade,
    Grid,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';

import {
    // ArrowForward,
    CalendarMonth,
    Close,
    Public,
    Share,
    // Visibility,
    ZoomIn,
} from '@mui/icons-material';

import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import api from '../../../services/api';

import HeaderSession from '../../../utils/headerSession';
// import TextFormatado from '../../../utils/TextFormatado';
import Date from '../../../utils/date';
import Loading from '../../../load/loading';
import RegisterAccess from '../../../utils/registerAccess';

export default function ViewNoticia({ preview, criacao }) {

    const { id } = useParams();

    const navigate = useNavigate();

    const [noticia, setNoticia] = useState(preview || null);

    const [noticias, setNoticias] = useState([]);

    const [loading, setLoading] = useState(!preview);

    // MODAL IMAGEM
    const [openImage, setOpenImage] = useState(false);

    useEffect(() => {

        if (!preview) {
            carregarDados();
        }

    }, [id]);

    const carregarDados = async () => {

        try {

            setLoading(true);

            const [noticiaResponse, noticiasResponse] =
                await Promise.all([
                    api.get(`/noticia/${id}`),
                    api.get(`/noticias?seccao=Notícia`)
                ]);

            setNoticia(
                noticiaResponse?.data?.noticia || null
            );

            setNoticias(
                noticiasResponse?.data?.noticias?.filter(
                    (item) => item._id !== id
                ) || []
            );

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);
        }
    };

    // IMAGEM PRINCIPAL
    const imagemPrincipal = useMemo(() => {

        if (!noticia?.imagem) {
            return '/sem-imagem.png';
        }

        // Preview local
        if (
            criacao &&
            noticia?.imagem instanceof File
        ) {
            return URL.createObjectURL(
                noticia.imagem
            );
        }

        return noticia.imagem;

    }, [noticia, criacao]);

    // SHARE
    const handleShare = async () => {

        const shareData = {
            title: noticia?.titulo,
            text: noticia?.subTitulo,
            url: window.location.href,
        };

        try {

            if (navigator.share) {

                await navigator.share(shareData);

            } else {

                await navigator.clipboard.writeText(
                    window.location.href
                );

                alert('Link copiado.');

            }

        } catch (error) {

            console.log(error);

        }
    };

    if (loading) {

        return (
            <div style={{ minHeight: '100vh', }}>
                <Loading text="A carregar notícia..." />
            </div>
        );
    }

    return (

        <Box
            sx={{
                background:
                    'linear-gradient(to bottom, #f4f6fb, #ffffff)',
                minHeight: '100vh',
                pb: 10,
            }}
        >
            <RegisterAccess page="visualizar noticia" />

            <Container
                maxWidth="xl"
                sx={{
                    pt: 4,
                }}
            >

                {!preview && (
                    <HeaderSession title="NOTÍCIAS" />
                )}

                {noticia && (

                    <Fade in timeout={700}>

                        <Box>

                            {/* HERO */}
                            <Card
                                elevation={0}
                                sx={{
                                    overflow: 'hidden',
                                    borderRadius: 2,
                                    position: 'relative',
                                    mb: 8,
                                    background: '#fff',
                                    boxShadow:
                                        '0 20px 80px rgba(0,0,0,.08)',
                                }}
                            >

                                {/* IMAGEM */}
                                <Box
                                    sx={{
                                        position: 'relative',
                                        height: {
                                            xs: 350,
                                            md: 680,
                                        },
                                        overflow: 'hidden',
                                        cursor: 'zoom-in',
                                    }}
                                    onClick={() =>
                                        setOpenImage(true)
                                    }
                                >

                                    <img
                                        src={imagemPrincipal}
                                        alt={noticia?.titulo}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: '.5s',
                                        }}
                                    />

                                    {/* OVERLAY */}
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            inset: 0,
                                            background:
                                                'linear-gradient(to top, rgba(0,0,0,.88), rgba(0,0,0,.2))',
                                        }}
                                    />

                                    {/* TOP ACTIONS */}
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 20,
                                            left: 20,
                                            right: 20,
                                            display: 'flex',
                                            justifyContent:
                                                'space-between',
                                            alignItems: 'center',
                                        }}
                                    >

                                        {noticia?.categoria && (

                                            <Chip
                                                label={
                                                    noticia?.categoria
                                                }
                                                sx={{
                                                    background:
                                                        'rgba(255,255,255,.18)',
                                                    color: '#fff',
                                                    fontWeight:
                                                        'bold',
                                                    backdropFilter:
                                                        'blur(20px)',
                                                    px: 1,
                                                    py: 2.5,
                                                }}
                                            />
                                        )}

                                        <Stack
                                            direction="row"
                                            spacing={1}
                                        >

                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleShare();
                                                }}
                                                sx={{
                                                    background:
                                                        'rgba(255,255,255,.18)',
                                                    color: '#fff',
                                                    backdropFilter:
                                                        'blur(20px)',

                                                    '&:hover':
                                                    {
                                                        background:
                                                            'rgba(255,255,255,.3)',
                                                    }
                                                }}
                                            >
                                                <Share />
                                            </IconButton>

                                            <IconButton
                                                sx={{
                                                    background:
                                                        'rgba(255,255,255,.18)',
                                                    color: '#fff',
                                                    backdropFilter:
                                                        'blur(20px)',

                                                    '&:hover':
                                                    {
                                                        background:
                                                            'rgba(255,255,255,.3)',
                                                    }
                                                }}
                                            >
                                                <ZoomIn />
                                            </IconButton>

                                        </Stack>

                                    </Box>

                                    {/* TEXTO */}
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            width: '100%',
                                            p: {
                                                xs: 3,
                                                md: 7,
                                            },
                                            color: '#fff',
                                        }}
                                    >

                                        <Typography
                                            variant="h2"
                                            fontWeight="900"
                                            lineHeight={1.05}
                                            sx={{
                                                fontSize: {
                                                    xs: 34,
                                                    md: 68,
                                                },
                                                mb: 3,
                                                maxWidth: 1000,
                                                textShadow:
                                                    '0 5px 20px rgba(0,0,0,.4)',
                                            }}
                                        >
                                            {noticia?.titulo}
                                        </Typography>

                                        {noticia?.subTitulo && (

                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    maxWidth: 850,
                                                    opacity: .92,
                                                    lineHeight: 1.8,
                                                    fontWeight:
                                                        300,
                                                    mb: 4,
                                                }}
                                            >
                                                {
                                                    noticia?.subTitulo
                                                }
                                            </Typography>
                                        )}

                                        {/* META */}
                                        <Stack
                                            direction="row"
                                            spacing={4}
                                            flexWrap="wrap"
                                        >

                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                alignItems="center"
                                            >
                                                <CalendarMonth />

                                                <Typography>
                                                    <Date
                                                        date={
                                                            noticia?.updatedAt
                                                        }
                                                    />
                                                </Typography>
                                            </Stack>

                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                alignItems="center"
                                            >
                                                <Public />

                                                <Typography>
                                                    {
                                                        noticia?.fonte
                                                    }
                                                </Typography>
                                            </Stack>
                                            {/* 
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                alignItems="center"
                                            >
                                                <Visibility />

                                                <Typography>
                                                    {
                                                        noticia?.views ||
                                                        0
                                                    } visualizações
                                                </Typography>
                                            </Stack> */}

                                        </Stack>

                                    </Box>

                                </Box>

                            </Card>

                            {/* CONTENT */}
                            <Grid container spacing={5}>

                                {/* TEXTO */}
                                <Grid item xs={12} lg={8}>

                                    <Card
                                        elevation={0}
                                        sx={{
                                            borderRadius: 2,
                                            p: {
                                                xs: 2,
                                                md: 5,
                                            },
                                            background:
                                                'rgba(255,255,255,.85)',
                                            backdropFilter:
                                                'blur(20px)',
                                            boxShadow:
                                                '0 10px 50px rgba(0,0,0,.06)',
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                fontSize: 18,
                                                lineHeight: 2,
                                                color: '#2d3748',

                                                '& p': {
                                                    mb: 3,
                                                },

                                                '& img': {
                                                    width: '100%',
                                                    borderRadius: 2,
                                                    marginTop: 4,
                                                    marginBottom: 4,
                                                },
                                            }}
                                        >
                                            {/* <TextFormatado
                                                texto={
                                                    noticia?.conteudo
                                                }
                                            /> */}
                                            <div style={{ marginTop: 20, lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: noticia?.conteudo }} />

                                        </Box>

                                    </Card>

                                </Grid>

                                {/* SIDEBAR */}
                                <Grid item xs={12} lg={4}>

                                    <Stack spacing={4}>

                                        {/* AUTOR */}
                                        <Card
                                            elevation={0}
                                            sx={{
                                                borderRadius: 2,
                                                p: 3,
                                                background:
                                                    '#fff',
                                                boxShadow:
                                                    '0 10px 40px rgba(0,0,0,.05)',
                                            }}
                                        >

                                            <Typography
                                                variant="h6"
                                                fontWeight="bold"
                                                mb={3}
                                            >
                                                Publicado por
                                            </Typography>

                                            <Stack
                                                direction="row"
                                                spacing={2}
                                                alignItems="center"
                                            >

                                                <Avatar
                                                    sx={{
                                                        width: 65,
                                                        height: 65,
                                                        fontSize: 24,
                                                        background:
                                                            '#85287e',
                                                    }}
                                                >
                                                    A
                                                </Avatar>

                                                <Box>

                                                    <Typography
                                                        fontWeight="bold"
                                                        fontSize={
                                                            18
                                                        }
                                                    >
                                                        ARMED
                                                    </Typography>

                                                    <Typography
                                                        color="text.secondary"
                                                    >
                                                        Portal Oficial
                                                    </Typography>

                                                </Box>

                                            </Stack>

                                        </Card>

                                        {/* OUTRAS NOTÍCIAS */}
                                        <Card
                                            elevation={0}
                                            sx={{
                                                borderRadius: 2,
                                                p: 3,
                                                background:
                                                    '#fff',
                                                boxShadow:
                                                    '0 10px 40px rgba(0,0,0,.05)',
                                            }}
                                        >

                                            <Typography
                                                variant="h6"
                                                fontWeight="bold"
                                                mb={3}
                                            >
                                                Outras Notícias
                                            </Typography>

                                            <Stack spacing={3}>

                                                {noticias
                                                    ?.slice(0, 5)
                                                    .map(
                                                        (
                                                            item
                                                        ) => (

                                                            <Box
                                                                key={
                                                                    item._id
                                                                }
                                                                onClick={() =>
                                                                    navigate(
                                                                        `/view-noticia/${item._id}`
                                                                    )
                                                                }
                                                                sx={{
                                                                    cursor:
                                                                        'pointer',
                                                                    transition:
                                                                        '.3s',

                                                                    '&:hover':
                                                                    {
                                                                        transform:
                                                                            'translateX(6px)',
                                                                    },
                                                                }}
                                                            >

                                                                <Stack
                                                                    direction="row"
                                                                    spacing={
                                                                        2
                                                                    }
                                                                >

                                                                    <img
                                                                        src={
                                                                            item?.imagem
                                                                        }
                                                                        alt={
                                                                            item?.titulo
                                                                        }
                                                                        style={{
                                                                            width: 110,
                                                                            height: 90,
                                                                            objectFit:
                                                                                'cover',
                                                                            borderRadius: 16,
                                                                        }}
                                                                    />

                                                                    <Box>

                                                                        <Typography
                                                                            fontWeight="bold"
                                                                            sx={{
                                                                                lineHeight: 1.4,
                                                                                mb: 1,
                                                                            }}
                                                                        >
                                                                            {
                                                                                item?.titulo
                                                                            }
                                                                        </Typography>

                                                                        <Typography
                                                                            variant="caption"
                                                                            color="text.secondary"
                                                                            display={'flex'}
                                                                            alignItems={'center'}
                                                                        >
                                                                            <CalendarMonth />
                                                                            <Date
                                                                                date={
                                                                                    item?.updatedAt
                                                                                }
                                                                            />
                                                                        </Typography>

                                                                    </Box>

                                                                </Stack>

                                                                <Divider
                                                                    sx={{
                                                                        mt: 2,
                                                                    }}
                                                                />

                                                            </Box>
                                                        )
                                                    )}

                                            </Stack>

                                        </Card>

                                    </Stack>

                                </Grid>

                            </Grid>


                            {/* MAIS NOTÍCIAS */}
                            <Divider sx={{ my: 4 }} />
                            {noticias?.length > 0 && (

                                <Box mt={8}>

                                    <Typography
                                        variant="h4"
                                        fontWeight="bold"
                                        mb={4}
                                    >
                                        Mais Notícias
                                    </Typography>

                                    <Grid container spacing={4}>

                                        {noticias?.slice(5, noticias.length).map((item) => (

                                            <Grid
                                                item
                                                xs={12}
                                                md={4}
                                                key={item._id}
                                            >

                                                <Card
                                                    onClick={() =>
                                                        navigate(
                                                            `/view-noticia/${item._id}`
                                                        )
                                                    }
                                                    sx={{
                                                        cursor: 'pointer',
                                                        borderRadius: 2,
                                                        overflow: 'hidden',
                                                        transition: '.4s',
                                                        minHeight: 450,

                                                        '&:hover': {
                                                            transform:
                                                                'translateY(-5px)',
                                                            boxShadow: 6,
                                                        }
                                                    }}
                                                >

                                                    <img
                                                        src={item?.imagem}
                                                        alt={item?.titulo}
                                                        style={{
                                                            width: '100%',
                                                            height: 220,
                                                            objectFit: 'cover',
                                                        }}
                                                    />

                                                    <CardContent>

                                                        <Typography
                                                            variant="h6"
                                                            fontWeight="bold"
                                                            gutterBottom
                                                        >
                                                            {item?.titulo}
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            sx={{
                                                                mb: 2,
                                                            }}
                                                        >
                                                            {item?.subTitulo
                                                                ?.slice(0, 120)}
                                                            ...
                                                        </Typography>

                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                            display={'flex'}
                                                            alignItems={'center'}
                                                        >
                                                            <CalendarMonth />
                                                            <Date
                                                                date={
                                                                    item?.updatedAt
                                                                }
                                                            />
                                                        </Typography>

                                                    </CardContent>

                                                </Card>

                                            </Grid>
                                        ))}

                                    </Grid>

                                </Box>
                            )}
                        </Box>
                    </Fade>
                )}
            </Container>

            {/* MODAL IMAGEM */}
            <Dialog
                open={openImage}
                onClose={() => setOpenImage(false)}
                maxWidth="xl"
                fullWidth
                PaperProps={{
                    sx: {
                        background: 'transparent',
                        boxShadow: 'none',
                        overflow: 'hidden',
                    }
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        background: '#000',
                        borderRadius: 2,
                        overflow: 'hidden',
                    }}
                >
                    {/* FECHAR */}
                    <IconButton
                        onClick={() =>
                            setOpenImage(false)
                        }
                        sx={{
                            position: 'absolute',
                            top: 15,
                            right: 15,
                            zIndex: 10,
                            background:
                                'rgba(255,255,255,.15)',
                            color: '#fff',

                            '&:hover': {
                                background:
                                    'rgba(255,255,255,.25)',
                            }
                        }}
                    >
                        <Close />
                    </IconButton>

                    {/* IMAGEM */}
                    <img
                        src={imagemPrincipal}
                        alt={noticia?.titulo}
                        style={{
                            width: '100%',
                            maxHeight: '95vh',
                            objectFit: 'contain',
                            display: 'block',
                            background: '#000',
                        }}
                    />

                </Box>

            </Dialog>
        </Box>
    );
}